import { render, staticRenderFns } from "./AuditTabPane.vue?vue&type=template&id=0c340694&scoped=true&"
import script from "./AuditTabPane.vue?vue&type=script&lang=ts&"
export * from "./AuditTabPane.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c340694",
  null
  
)

export default component.exports